var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueFeedback',{attrs:{"type":"error"}},[_c('template',{slot:"feedback-title"},[_vm._v("A technical error has occurred")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }